import React from 'react'
import "./signup-login-image.css"

function SignupImage() {
    return (
        <div className='signup-image-div'>
            <div className='signup-image'></div>
            <div className="overlay-div"></div>
            <div className="overlay-text-div tagLineContainer">
                {/* <Typography component="h4" variant="h4">Your 24/7 Intelligent Talent Specialist</Typography>
                <Typography component="p" variant="p">&nbsp; Enhancing human potential with AI</Typography> */}
                <span className='line1_headline'>Your 24/7 Intelligent Talent Specialist</span>
                <span className='line2_headline'>Enhancing human potential with AI</span>
                <span className='line3_headline'>From incomplete job and skill ideas to crystal-clear job descriptions and job postings: Noah.ai streamlines how recruiters craft JDs</span>
                
            </div>
        </div>
    )
}


export default SignupImage
